import { ISideMenuCategoryLang } from '../../../types/lang'

export const sideMenuCategoryLang: ISideMenuCategoryLang = {
	side_menu_category: {
		affiliate_title: 'Affiliate_ru',
		revenue_title: 'Revenue_ru',
		profile_title: 'PROFILE_ru',
	}
}